import React, { useEffect, useRef, useState } from 'react'
import { TimelineEvent } from 'react-event-timeline'
import Linkify from 'react-linkify'

import { Box, Flex, Icon, Link, Text, theme } from '@driftt/dds'
import { faSalesforce } from '@driftt/dds.icons/brands/faSalesforce'

const BubbleStyles: Record<string, Record<string, any>> = {
  Email: {
    borderColor: theme.colors.white,
    backgroundColor: theme.colors.indigo7
  },
  'Inbound Email': {
    borderColor: theme.colors.white,
    backgroundColor: theme.colors.pink7
  },
  'Outbound Email': {
    borderColor: theme.colors.white,
    backgroundColor: theme.colors.lime7
  },
  'Email Opened': {
    borderColor: theme.colors.white,
    backgroundColor: theme.colors.cyan7
  },
  'Email Reply': {
    borderColor: theme.colors.white,
    backgroundColor: theme.colors.purple7
  },
  'Email Clicked': {
    borderColor: theme.colors.white,
    backgroundColor: theme.colors.teal7
  },
  'Video Call': {
    borderColor: theme.colors.white,
    backgroundColor: theme.colors.red7
  }
}

const SalesforceTaskCard = ({
  icon,
  type,
  date,
  Subject,
  Description,
  Who,
  Owner,
  WhoId,
  AccountId
}: any) => {
  const [showMore, setShowMore] = useState<boolean>(false)
  const [hasShowMore, setHasShowMore] = useState<boolean>(true)
  const contentRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (contentRef?.current && contentRef.current.clientHeight < 20 && !hasShowMore) {
      setHasShowMore(false)
    }
  }, [contentRef, setHasShowMore, hasShowMore])
  return (
    <TimelineEvent
      titleStyle={{
        fontFamily: theme.fonts.primary,
        fontSize: theme.fontSizes[2]
      }}
      bubbleStyle={BubbleStyles[type]}
      icon={<Icon icon={icon} color={theme.colors.white.toString()} />}
      subtitle={date}
      title={type}>
      <Flex gap="half" direction="column" css={{ width: '100%' }}>
        <Flex alignItems="center" css={{ width: '100%', paddingBottom: '$1' }}>
          <Icon size="extra-large" color="var(--drift-dds-colors-blue8)" icon={faSalesforce}></Icon>
          <Text variant="metadata">Synced from Salesforce</Text>
        </Flex>
        <Flex gap="half" css={{ width: '100%' }}>
          <Text variant="bodyBold">Subject:</Text>
          <Text variant="body" truncate>
            {Subject}
          </Text>
        </Flex>
        <Flex gap="half" justifyContent="space-between" css={{ width: '100%' }}>
          <Box>
            <Text variant="bodyBold" as="span">
              Contact Name:{' '}
            </Text>
            <Text variant="body" as="span">
              {Who?.Name}
            </Text>
          </Box>
          {WhoId && (
            <Link
              type="primary"
              target="_blank"
              href={`https://${'drift'}.lightning.force.com/lightning/r/Contact/${WhoId}/view`}>
              View in Salesforce
            </Link>
          )}
        </Flex>
        <Flex
          gap="half"
          justifyContent="space-between"
          css={{ width: '100%', paddingBottom: '$1' }}>
          <Box>
            <Text variant="bodyBold" as="span">
              Owner:{' '}
            </Text>
            <Text variant="body" as="span">
              {Owner.Name || Owner.Email}
            </Text>
          </Box>
          {AccountId && (
            <Link
              type="primary"
              target="_blank"
              href={`https://${'drift'}.lightning.force.com/lightning/r/Account/${AccountId}/view`}>
              View Account in Salesforce
            </Link>
          )}
        </Flex>
        {hasShowMore && !showMore && (
          <Flex
            css={{ width: '100%', paddingTop: '$1', borderTop: '$gray3 solid 1px' }}
            justifyContent="flex-end">
            <Link type="primary" onClick={() => setShowMore(true)}>
              View more
            </Link>
          </Flex>
        )}
        <Box css={{ width: '100%', paddingBottom: '$1' }}>
          <Linkify>
            <div ref={contentRef}>
              {(showMore || !hasShowMore) && (
                <Box
                  as="div"
                  css={{
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    maxHeight: '400px',
                    whiteSpace: 'break-spaces',
                    wordBreak: 'break-spaces',
                    fontSize: '$2',
                    wordWrap: 'break-word',
                    padding: '$1'
                  }}>
                  {Description}
                </Box>
              )}
            </div>
          </Linkify>
        </Box>
        {hasShowMore && showMore && (
          <Flex
            css={{ width: '100%', paddingTop: '$1', borderTop: '$gray3 solid 1px' }}
            justifyContent="flex-end">
            <Link type="primary" onClick={() => setShowMore(false)}>
              Show less
            </Link>
          </Flex>
        )}
      </Flex>
    </TimelineEvent>
  )
}

export default SalesforceTaskCard
